module.exports = __webpack_public_path__ + "img/test2.5eabffdb.png";